import errorParser from '@/utils/error-parser'
import RestResourceService from "@/services/RestResourcesService";
import {FUNCTIONALITY_TYPES} from "@/constants/functionality-types";
import MapService from "@/services/MapService";

function initialState() {
    return {
        data: [],
        currentVersion: "",
        overlapDetected: false,
        loading: true
    }
}

export default {
    state: initialState(),
    getters: {
        DATA: state => state.data,
        DATA_LOADING: state => state.loading,
        CURRENT_VERSION: state => state.currentVersion,
        OVERLAP_DETECTED: state => state.overlapDetected,

    },
    mutations: {
        SET_DATA(state, payload) {
            state.data = payload;
        },
        SET_OVERLAP_DETECTED(state, payload) {
            state.overlapDetected = payload;
        },
        SET_CURRENT_VERSION(state, payload) {
            state.currentVersion = payload;
        },
        SET_LOADING(state, payload) {
            state.loading = payload;
        },
        RESET(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        }
    },
    actions: {
        GET_ENTITY_VERSIONS: ({}, url) => {
            return RestResourceService.getResources(url);
            },
        GET_DATA: ({commit, dispatch, getters}, payload) => {
            commit('SET_LOADING', true);

            return RestResourceService.getResources(payload.url)
                .then((response) => {
                    switch (payload.type) {
                        case FUNCTIONALITY_TYPES.dependency:

                            commit('SET_DATA', {
                                dependencies: [...MapService.mapDependencyUrl(response.data.dependencies)]
                            });
                            break;
                        case  FUNCTIONALITY_TYPES.suggest:
                            if(!response.data.results) {
                                commit("SET_DATA", {
                                    ...response.data,
                                    results: []
                                })
                            }
                            else {
                                commit("SET_DATA", response.data)
                            }
                            break;
                        case FUNCTIONALITY_TYPES.search :
                        case FUNCTIONALITY_TYPES.navigation:
                            if (!response.data.indexCodeOptions || response.data.indexCodeOptions.length < 0) {
                                commit('SET_DATA', response.data);
                            }


                            commit('SET_DATA', {
                                ...response.data,
                                indexCodeOptions: MapService.mapIndexCodeOptions(response.data.indexCodeOptions || [],   getters.CURRENT_TENANT.code),
                            });
                            break;
                        case FUNCTIONALITY_TYPES.dictionary:
                            if (!response.data.tags || !response.data.tags.length <= 0) {
                                commit('SET_DATA', response.data);
                            }

                            commit('SET_DATA', {
                                ...response.data,
                                tags: MapService.mapStringArrayToObjectArray(response.data.tags, 'tag')
                            });

                            break;
                        default:
                            commit('SET_DATA', response.data);
                    }



                    commit('SET_LOADING', false);

                    setTimeout(() => {
                        dispatch('UPDATE_SAVE_STATUS', {
                            status: true
                        });
                    }, 500);

                    return response.data;
                })
                .catch((error) => {

                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: true,
                    });
                    throw new Error(error);
                })
        }, 
        GET_VERSION_DATA: ({}, payload) => {
            return RestResourceService.getResources(payload.url)
                .then((response) => {
                        return response.data;
                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: true,
                    });
                    throw new Error(error);
                })
        },
        POST_IMPORT_DATA: ({commit, dispatch}, payload) => {
            return RestResourceService.postResources(payload.url, payload.form)
                .then((response) => {
                    setTimeout(() => {
                        dispatch('UPDATE_SAVE_STATUS', {
                            status: true
                        });
                    }, 300);

                    return response.data;
                })

        },
        UPDATE_DATA: ({commit, getters, dispatch}, payload) => {
            const prevOverlab = payload.preventOverlap ? "?preventOverlap=true" : "";
            commit("SET_OVERLAP_DETECTED", false);
            return RestResourceService.updateResources(payload.url+prevOverlab, getters.DATA)
                .then((response) => {

                    switch (payload.type) {

                        case FUNCTIONALITY_TYPES.dependency:
                            commit('SET_DATA', {
                                dependencies: [...MapService.mapDependencyUrl(response.data.dependencies)]
                            });

                            break;
                        case FUNCTIONALITY_TYPES.search :
                        case FUNCTIONALITY_TYPES.navigation:
                            if (!response.data.indexCodeOptions || response.data.indexCodeOptions.length < 0) {
                                commit('SET_DATA', response.data);
                            }


                            commit('SET_DATA', {
                                ...response.data,
                                indexCodeOptions: MapService.mapIndexCodeOptions(response.data.indexCodeOptions || [],  getters.CURRENT_TENANT.code),
                            });

                            break;
                        case FUNCTIONALITY_TYPES.dictionary:
                            if (!response.data.tags || !response.data.tags.length <= 0) {
                                commit('SET_DATA', response.data);
                            }

                            commit('SET_DATA', {
                                ...response.data,
                                tags: MapService.mapStringArrayToObjectArray(response.data.tags, 'tag')
                            });


                            break;
                        default:
                            commit('SET_DATA', response.data);

                    }



                    setTimeout(() => {
                        dispatch('UPDATE_SAVE_STATUS', {
                            status: true
                        });
                    }, 300);

                    return response.data;
                })
                .catch((error) => {
                    if(error && error.response) {
                        if(error.response.status === 409) {
                            commit("SET_OVERLAP_DETECTED", true);
                            setTimeout(() => {
                                commit("SET_OVERLAP_DETECTED", false);
                            }, 60000)

                        }
                    }
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: true,
                    });
                    throw new Error(error);
                })
        },
        DELETE_DATA: ({commit}, payload) => {
            return RestResourceService.deleteResources(payload.url)
                .then((response) => {
                    commit('SET_DATA', response.data);

                })
                .catch((error) => {
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: false,
                        redirectToLoginPage: false,
                        showNotification: false,
                    });
                    throw new Error(error);
                })
        },
        SET_DATA: ({commit}, data) => {
            commit('SET_DATA', data);
        },
        RESET_DATA: ({commit}) => {
            commit('RESET');
        },
    }
}
